/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Business,
    BusinessFromJSON,
    BusinessFromJSONTyped,
    BusinessToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateBulkBusinessActiveBody
 */
export interface UpdateBulkBusinessActiveBody {
    /**
     * 
     * @type {Array<Business>}
     * @memberof UpdateBulkBusinessActiveBody
     */
    businesses: Array<Business>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBulkBusinessActiveBody
     */
    isActive: boolean;
}

export function UpdateBulkBusinessActiveBodyFromJSON(json: any): UpdateBulkBusinessActiveBody {
    return UpdateBulkBusinessActiveBodyFromJSONTyped(json, false);
}

export function UpdateBulkBusinessActiveBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBulkBusinessActiveBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'businesses': ((json['businesses'] as Array<any>).map(BusinessFromJSON)),
        'isActive': json['isActive'],
    };
}

export function UpdateBulkBusinessActiveBodyToJSON(value?: UpdateBulkBusinessActiveBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'businesses': ((value.businesses as Array<any>).map(BusinessToJSON)),
        'isActive': value.isActive,
    };
}


